import posthog from 'posthog-js'

const GROUP_NAME = 'organization'

let isInitialized = false

export function usePostHog() {
  if (import.meta.env.VITE_POSTHOG_KEY && !isInitialized) {
    posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
      api_host: 'https://eu.i.posthog.com',
      defaults: '2025-05-24',
      person_profiles: 'identified_only',
      // ponytail: cookie on .ginjer.ai so an admin opt-out also silences the marketing site
      opt_out_capturing_persistence_type: 'cookie',
      before_send: (event) => {
        // ponytail: filter out browser extension noise (Grammarly, etc.)
        if (event?.properties?.$exception_values?.[0]?.includes('MethodName:update, ParamCount:')) {
          return null
        }
        return event
      },
    })
    isInitialized = true
  }

  return { posthog, GROUP_NAME }
}
